<template>

  <div class="pull_refresh flex center"
       ref="box">
    <div class="flex center">
      <img class="pull_refresh_icon"
           src="../../../assets/robot/commonQ/pull_refresh.png" />
      <div>下拉查看历史记录</div>
    </div>

  </div>
</template>

<script>
export default {
  name: "downFresh",
  props: {},
  data() {
    return {
      boxElem: null,
    };
  },
  mounted() {
    let that = this;
    let Box = this.$refs.box;
    // console.log("元素", Box);
    let offsetY, MoveOffset, timer;
    Box.addEventListener("touchstart", function (e) {
      console.log("开始点击", e.touches[0]);
      offsetY = e.touches[0].pageY; //点击的时候的开始位置
    });
    Box.addEventListener("touchmove", function (e) {
      MoveOffset = e.touches[0].pageY - offsetY;
      console.log("向下移动的距离", MoveOffset);
      if (MoveOffset < 50 && MoveOffset > 0) {
        Box.style.height = `${24 + MoveOffset}px`; //移动的过程中，改变高度
      }
    });
    Box.addEventListener("touchend", function (e) {
      console.log("结束移动", e.touches[0]);
      Box.style.height = `4.26vw`;
      if (MoveOffset > 20) {
        //下拉的距离超过20的时候，就去获取历史记录
        that.$emit("getOtherHistory");
      }
    });
  },
  watch: {},
  methods: {
    // getOtherHistory() {
    //   this.$emit("getOtherHistory");
    // },
  },
};
</script>

<style lang="stylus">
.container-Moblie {
  .pull_refresh {
    font-size: 24px;
    color: #666;
    width: 100%;
    // background-color: rgb(255, 112, 112);
    cursor: pointer;
    height: 32px;
    margin-top: 16px;
  }

  .pull_refresh_icon {
    width: 24px;
    height: 24px;
  }
}
</style>
